import { render } from "./identifiersComponent.vue?vue&type=template&id=30655c67&scoped=true"
import script from "./identifiersComponent.vue?vue&type=script&lang=js"
export * from "./identifiersComponent.vue?vue&type=script&lang=js"

import "./identifiersComponent.vue?vue&type=style&index=0&id=30655c67&lang=scss&scoped=true"
import "./identifiersComponent.vue?vue&type=style&index=1&id=30655c67&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30655c67"]])

export default __exports__